import React, { Component } from 'react';
import $ from '../../common/AjaxRequest';
import { Modal, Button, Icon, message, Tree, Input } from 'antd';
import API_URL from '../../common/url';

const TreeNode = Tree.TreeNode;

class CasCadeOption extends Component {
    state = {
        options : [],
        expandedKeys: [],
        visible: false,
    };

    show = (moduleDefineCode) => {
        this.setState({
            visible: true,
            moduleDefineCode,
            showCascader: true,
        }, () => {
            this.loadData();
        });
    };

    hide = () => {
        this.setState({
            visible: false,
            showCascader: false,
            expandedKeys: [],
        });
    };

    loadData = (filterFailOptionId) => {
        const { expandedKeys } = this.state;
        const { moduleDefineCode } = this.state;
        const options = {
            url: `${API_URL.executeMgr.listFilterFailOption}`,
            data: {
                moduleDefineCode,
                type: 'patient',
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    if (expandedKeys.length == 0 ) {
                        if (res.data && (res.data.length > 0)) {
                            res.data.map(item => {
                                if (item.deepValue == 1) {
                                    expandedKeys.push(item.filterFailOptionId + '');
                                }
                            })
                        }
                    }
                    this.setState({
                        dataList: res.data,
                        expandedKeys: [...expandedKeys, filterFailOptionId],
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    deleteConfirm = (filterFailOptionId, optionValue) => {
        Modal.confirm({
            iconType: 'exclamation-circle',
            title: `确定要删除选项“${optionValue}”吗?`,
            onOk: () => {
                this.deleteCascade(filterFailOptionId);
            },
        });
    }

    deleteCascade = (filterFailOptionId) => {
        const { moduleDefineCode } = this.state;
        const options = {
            url: API_URL.executeMgr.deleteFilterFailOption,
            data: {
                filterFailOptionId,
                moduleDefineCode
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.loadData();
                }
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    onExpand = (expandedKeys, node) => {
        this.setState({ expandedKeys });
    }

    showSetOption = params => {
        this.SetOptionRef.show(params);
    }

    loopMap = data => {
        return data.map(item => {
            if (item.children && (item.children.length > 0)) {
                if (item.deepValue <= 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionValue}
                                <Icon onClick={() => this.showSetOption({type: 'add', filterFailOptionParentId: item.filterFailOptionId, optionValue: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                {!!item.investigationId && <Icon onClick={() => this.showSetOption({type: 'edit', filterFailOptionId: item.filterFailOptionId, optionValue: item.optionValue})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />}
                                {!!item.investigationId && <Icon onClick={() => this.deleteConfirm(item.filterFailOptionId, item.optionValue)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />}
                            </div>}
                            key={item.filterFailOptionId + ''}
                        >
                            { this.loopMap(item.children) }
                        </TreeNode>
                    )
                } else if (item.deepValue > 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionValue}
                                <Icon onClick={() => this.showSetOption({type: 'add', filterFailOptionParentId: item.filterFailOptionId, optionValue: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                <Icon onClick={() => this.showSetOption({type: 'edit', filterFailOptionId: item.filterFailOptionId, optionValue: item.optionValue})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.filterFailOptionId, item.optionValue)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.filterFailOptionId + ''}
                        >
                            { this.loopMap(item.children) }
                        </TreeNode>
                    )
                }
            } else {
                if (item.deepValue <= 2) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionValue}
                                <Icon onClick={() => this.showSetOption({type: 'add', filterFailOptionParentId: item.filterFailOptionId, optionValue: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                {!!item.investigationId && <Icon onClick={() => this.showSetOption({type: 'edit', filterFailOptionId: item.filterFailOptionId, optionValue: item.optionValue})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />}
                                {!!item.investigationId && <Icon onClick={() => this.deleteConfirm(item.filterFailOptionId, item.optionValue)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />}
                            </div>}
                            key={item.filterFailOptionId + ''}
                        />
                    )
                } else if ((item.deepValue > 2) && (item.deepValue < 6)) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionValue}
                                <Icon onClick={() => this.showSetOption({type: 'add', filterFailOptionParentId: item.filterFailOptionId, optionValue: ''})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="plus-circle-o" />
                                <Icon onClick={() => this.showSetOption({type: 'edit', filterFailOptionId: item.filterFailOptionId, optionValue: item.optionValue})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.filterFailOptionId, item.optionValue)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.filterFailOptionId + ''}
                        />
                    )
                } else if (item.deepValue >= 6) {
                    return (
                        <TreeNode
                            title={<div className="violate_item">{item.optionValue}
                                <Icon onClick={() => this.showSetOption({type: 'edit', filterFailOptionId: item.filterFailOptionId, optionValue: item.optionValue})} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#66c9ee', cursor: 'pointer'}} type="edit" />
                                <Icon onClick={() => this.deleteConfirm(item.filterFailOptionId, item.optionValue)} style={{marginLeft: 6, fontSize: 14, verticalAlign: 'text-bottom',color: '#F00', cursor: 'pointer'}} type="close" />
                            </div>}
                            key={item.filterFailOptionId + ''}
                        />
                    )
                }
            }
        })
    }

    render() {
        const { visible, expandedKeys } = this.state;
        return (
            visible &&
            <Modal
                title="设置可选项"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div className="modal-content">
                        <Button type="primary" onClick={() => this.showSetOption({type: 'add', filterFailOptionParentId: '', optionName: ''})} >添加一级选项</Button>
                        <ul className="modal-list">
                            <li className="modal-item" style={{paddingBottom: 20}}>
                                <Tree
                                    showLine
                                    onExpand={this.onExpand}
                                    expandedKeys={expandedKeys}
                                >
                                    { this.getDataList() }
                                </Tree>
                            </li>
                        </ul>
                    </div>
                    <SetOption ref={el => this.SetOptionRef = el}  reLoad={this.loadData} />
                </div>
            </Modal>
        );
    }
}

class SetOption extends Component {
    state = {
        visible: false,
        confirmLoading: false,
    };

    show = params => {
        this.setState({
            params,
            visible: true
        });
    };

    hide = () => {
        this.setState({ visible: false });
    };

    confirm = () => {
        const { params } = this.state;
        const { type, optionValue = '' } = params;
        if (optionValue.trim() == '') {
            message.warning('请输入选项名称');
            return;
        }
        const  url = type == 'add' ? API_URL.executeMgr.addFilterFailOption : API_URL.executeMgr.modifyFilterFailOption;

        this.setState({ confirmLoading: true });
        const options = {
            method: 'POST',
            url,
            data: { ...params },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    message.success(res.success);
                    this.setState({
                        visible: false,
                        confirmLoading: false
                    }, () => {
                        this.props.reLoad(res.againstId + '');
                    });
                } else {
                    message.error(res.error);
                    this.setState({ confirmLoading: false });
                }
            }),
            errorResult: (() => {
                this.setState({ confirmLoading: false });
            })
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    render() {
        const { visible, confirmLoading, params = {} } = this.state;
        const { optionValue = '', type = '' } = params;
        return (
            <Modal
                title={ type == 'add'? '添加选项' : '修改选项'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.confirm}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
                confirmLoading={confirmLoading}
            >
                <div className="modal-content">
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 86, paddingRight: 10}}>选项名称:</div>
                            <div className="item-right">
                                <Input
                                    maxLength='30'
                                    value={optionValue}
                                    placeholder="请输入选项名称"
                                    onChange={e => this.handleInputChange(e, 'optionValue')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        );
    }
}

export default CasCadeOption ;


// WEBPACK FOOTER //
// ./src/components/executeMgr/CasCadeOption.js